import React, { useState } from "react";
import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import { containerVariants, itemVariants } from "./variants";
import { Eye, EyeOff } from "lucide-react";

// Same flow as sanwariyaLatest/src/pages/user/ChangePassword.js:
// validate() -> userAPI.updatePassword(payload) -> res.code === 200 -> toast
function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const validate = () => {
    const newErrors = {};

    if (!currentPassword) {
      newErrors.currentPassword = "Please Enter Current Password";
    } else if (currentPassword.length < 6) {
      newErrors.currentPassword = "Current Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.newPassword = "Please Enter New Password";
    } else if (newPassword.length <= 6) {
      newErrors.newPassword = "New Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password";
    } else if (confirmPassword.length <= 6) {
      newErrors.confirmPassword = "Confirm Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = { newPassword, currentPassword, confirmPassword };

    setSaving(true);
    try {
      const res = await userAPI.updatePassword(payload);
      if (res.code === 200) {
        showSuccess(res.message);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      key="changePassword"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0, scale: 0.97 }}
      className="flex flex-col gap-3.5"
    >
      <div className="mb-1">
        <span className="block mb-0.5 font-subheading text-[0.54rem] font-bold uppercase tracking-[0.2em] text-[var(--color-text-muted)]">
          Manage
        </span>
        <h2 className="font-heading text-[1.7rem] leading-none tracking-[-0.02em] text-[var(--color-text)]">
          Change Password
        </h2>
      </div>

      <motion.div variants={itemVariants} className="acc-card px-[18px] py-4">
        <span className="acc-eye flex items-center gap-1.5">
          {/* <KeyRound size={12} /> */}
           Update Password
        </span>

        <form onSubmit={handleDetailsSubmit} className="flex flex-col gap-3.5">
          <div>
            <label className="mb-1 block font-body text-[0.78rem] text-[var(--color-text-muted)]">
              Current Password
            </label>
            {/* <input
              className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 font-body text-[0.9rem]"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            /> */}
            <div className="relative">
              <input
                className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 pr-10 font-body text-[0.9rem]"
                type={showCurrentPassword ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 border-0 bg-transparent p-0 text-[var(--color-text-muted)] cursor-pointer"
                aria-label={
                  showCurrentPassword
                    ? "Hide password"
                    : "Show password"
                }
              >
                {showCurrentPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>
            {errors.currentPassword && (
              <span className="text-danger text-[0.7rem]">{errors.currentPassword}</span>
            )}
          </div>

          <div>
            <label className="mb-1 block font-body text-[0.78rem] text-[var(--color-text-muted)]">
              New Password
            </label>
            {/* <input
              className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 font-body text-[0.9rem]"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            /> */}
            <div className="relative">
              <input
                className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 pr-10 font-body text-[0.9rem]"
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 border-0 bg-transparent p-0 text-[var(--color-text-muted)] cursor-pointer"
                aria-label={showNewPassword ? "Hide password" : "Show password"}
              >
                {showNewPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>
            {errors.newPassword && (
              <span className="text-danger text-[0.7rem]">{errors.newPassword}</span>
            )}
          </div>

          <div>
            <label className="mb-1 block font-body text-[0.78rem] text-[var(--color-text-muted)]">
              Confirm Password
            </label>
            {/* <input
              className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 font-body text-[0.9rem]"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            /> */}
            <div className="relative">
              <input
                className="tf-field-input tf-input w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] px-2.5 py-2 pr-10 font-body text-[0.9rem]"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 border-0 bg-transparent p-0 text-[var(--color-text-muted)] cursor-pointer"
                aria-label={
                  showConfirmPassword
                    ? "Hide password"
                    : "Show password"
                }
              >
                {showConfirmPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>
            {errors.confirmPassword && (
              <span className="text-danger text-[0.7rem]">{errors.confirmPassword}</span>
            )}
          </div>

          <button type="submit" disabled={saving} className="acc-btn-p w-max disabled:cursor-not-allowed disabled:opacity-60">
            {saving ? "Updating..." : "Update Password"}
          </button>
        </form>
      </motion.div>
    </motion.div>
  );
}

export default ChangePassword;